import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DashboardState, PaginationState } from 'src/types/dashboard';

const initialState: DashboardState = {
  pagination: {
    current: 1,
    pageSize: 20,
    total: 0,
  },
  applicants: [],
  latestCursor: '',
  filter: {
    kyc_status: 'KYC_STATUS_UNKNOWN',
    bucket: '',
    products: [],
  },
  count: 0,
  searchText: '',
  searchedColumn: '',
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setPagination: (state, action: PayloadAction<PaginationState>) => {
      state.pagination = action.payload;
    },
    setLatestCursor: (state, action) => {
      state.latestCursor = action.payload;
    },
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
    setSearchText: (state, action) => {
      state.searchText = action.payload;
    },
    setSearchedColumn: (state, action) => {
      state.searchedColumn = action.payload;
    },
    resetDashboardState: () => initialState,
  },
});

export const {
  setPagination,
  setLatestCursor,
  setFilter,
  setSearchText,
  setSearchedColumn,
  resetDashboardState,
} = dashboardSlice.actions;

export const dashboardReducer = dashboardSlice.reducer;
